module.exports = __webpack_public_path__ + "od-store/od-store-72f69a10e0ea2619b60c485c4c267ee3.svg";